(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  function updateScrollRotation() {
    ticking = false;

    if (motionQuery.matches) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;
    const stickers = document.querySelectorAll('.beaming-sticker[data-rotation-behavior="scroll"]');

    stickers.forEach((sticker) => {
      const speed = Number(sticker.dataset.scrollSpeed || 4);
      const degrees = scrollY * speed * 0.035;
      sticker.style.setProperty('--beaming-sticker-scroll-rotate', `${degrees}deg`);
    });
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollRotation);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateScrollRotation, { once: true });
  } else {
    updateScrollRotation();
  }

  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', updateScrollRotation);
  }
})();
